__turbopack_context__.v({
  "readOnly": "_6gZOKq_readOnly",
});
